/**
 * Attempts to build the URL for our back-end.
 */
import { Environment, getEnv } from 'app/utils/getEnv';

export const getGraphqlUrl = () => {
    const env = getEnv( window.location.hostname );
    switch ( env ) {
        case Environment.PROD:
            return 'https://prod-hoya-graphql.biwlearning-hoya.com/graphql';
        case Environment.PPRD:
            return 'https://pprd-hoya-graphql.biwlearning-hoya.com/graphql';
        case Environment.QA:
            return 'https://qa-hoya-graphql.biwlearning-hoya.com/graphql';
        default:
            return 'http://localhost:4000/graphql';
    }
};
